export default __webpack_public_path__ + "static/media/img_step2.d96987ff.svg";